import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface MenuItem {
  label: string;
  onSelect: () => void;
  /** A destructive item reads in `negative`; it is still text, never colour alone. */
  destructive?: boolean;
}

interface Props {
  trigger: ReactNode;
  items: MenuItem[];
}

/** Row and page-level action menus (§4). */
export function DropdownMenu({ trigger, items }: Props) {
  return (
    <RadixDropdownMenu.Root>
      <RadixDropdownMenu.Trigger asChild>{trigger}</RadixDropdownMenu.Trigger>
      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          sideOffset={4}
          align="end"
          className="z-50 min-w-40 rounded border border-rule bg-paper p-1 shadow-overlay"
        >
          {items.map((item) => (
            <RadixDropdownMenu.Item
              key={item.label}
              onSelect={item.onSelect}
              className={cn(
                'cursor-pointer rounded px-2 py-1.5 text-sm outline-none',
                'data-[highlighted]:bg-paper-sunken',
                item.destructive ? 'text-negative' : 'text-ink-900',
              )}
            >
              {item.label}
            </RadixDropdownMenu.Item>
          ))}
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
}
